"use client";

import { useEffect, useState } from "react";

// Generic debounce hook
export function useDebounce<T>(value: T, delay: number = 500): T {
	const [debouncedValue, setDebouncedValue] = useState<T>(value);

	useEffect(() => {
		const timer = setTimeout(() => {
			setDebouncedValue(value);
		}, delay);

		return () => {
			clearTimeout(timer); // cleanup on value/delay change
		};
	}, [value, delay]);

	return debouncedValue;
}
